import { AssetsData } from 'structure/pv2/vault/hooks/useUserTotalAssets';
import { formatUnits } from 'viem';
import { TOKENS } from 'utils/constants/tokens';
import {
  TokenAction,
  TokenRecordType,
  TokenTableRow,
} from 'structure/capital-manager/types';

export const formatUSDQuoteAmount = (amount: bigint) => {
  return formatUnits(amount, TOKENS.BASE_L2.USDC.decimals);
};

export const getTokenQuoteAmount = (
  assetsData: AssetsData,
  token: `0x${string}`,
  chainId: number
) => {
  if (!assetsData) return BigInt(0);
  return assetsData.map[chainId]?.[token]?.quote ?? BigInt(0);
};

export const getTokenBalance = (props: {
  assetsData?: AssetsData;
  tokenAddress: `0x${string}`;
  chainId: number;
}) => {
  const { assetsData, tokenAddress, chainId } = props;
  if (!assetsData) return BigInt(0);
  return assetsData.map[chainId]?.[tokenAddress]?.balance ?? BigInt(0);
};

const isLockedToken = (token: TokenTableRow) => {
  return token.recordType === TokenRecordType.LockedToken;
};

const isIdleToken = (token: TokenTableRow) => {
  if (token.tokenAction === TokenAction.Zap && token.isDeposit) {
    return true;
  }

  if (token.tokenAction === TokenAction.BuySFI) {
    return true;
  }

  if (token.tokenAction === TokenAction.Stake) {
    return true;
  }

  if (token.tokenAction === TokenAction.Migrate) {
    return true;
  }

  return false;
};

const filterThirdPartyToken = (token: TokenTableRow) => {
  return token.tokenAction === TokenAction.Zap && !token.isDeposit;
};

export const filterIdleTokens = (tokens: TokenTableRow[]) => {
  return tokens.filter((token) => {
    return isIdleToken(token) && !isLockedToken(token);
  });
};

export const filterThirdPartyTokens = (tokens: TokenTableRow[]) => {
  return tokens.filter((token) => {
    return filterThirdPartyToken(token) && !isLockedToken(token);
  });
};
